import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {ContractLinkSummaries} from '../models/contract-link';

export const addInvoiceManagementActionTypes = {
  ADD: type('[Invoice Management] Add'),
  ADD_SUCCESS: type('[Invoice Management] Add Success'),
  ADD_FAIL: type('[Invoice Management] Add Fail')
};

export class AddInvoiceManagementAction implements Action {
  readonly type = addInvoiceManagementActionTypes.ADD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}


export class AddInvoiceManagementSuccessAction implements Action {
  readonly type = addInvoiceManagementActionTypes.ADD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?:  any) {}
}

export class AddInvoiceManagementFailAction implements Action {
  readonly type = addInvoiceManagementActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}
